import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, lastValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BaseApiService } from '../_base-http/base-api.service';
import { StateService } from './state.service';

@Injectable({
  providedIn: 'root',
})
export class ConfigurationService extends BaseApiService {
  private _imgBaseUrl = environment.imgBaseUrl;
  private _fileBaseUrl = environment.fileBaseUrl;

  isMobile = false;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public configs = new BehaviorSubject<any[]>([]);
  private configurationRequests = new Map<string, Promise<any[]>>();

  constructor(
    private _http: HttpClient,
    private _stateService: StateService,
  ) {
    super(_http, _stateService);
  }

  get imgBaseUrl() {
    return this._imgBaseUrl;
  }

  get fileBaseUrl() {
    return this._fileBaseUrl;
  }

  getAllConfiguration(): Promise<any[]> {
    const language = this._stateService.currentLanguage$.getValue();
    const existingRequest = this.configurationRequests.get(language);
    if (existingRequest) return existingRequest;

    const params = this.applyQuery();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const allConfig$ = this.http.get<any>(`${this.baseApiUrl}configuration/get-list-all-paging`, {
      params,
    });
    const request = lastValueFrom(allConfig$).then((response) => {
      const allConfig = response?.items || [];
      if (this._stateService.currentLanguage$.getValue() === language) {
        this.configs.next(allConfig);
      }
      return allConfig;
    });

    this.configurationRequests.set(language, request);
    request.catch(() => this.configurationRequests.delete(language));
    return request;
  }
}
